(() => {
  const root = document.querySelector('[data-cdb-home]');
  if (!root) return;

  const routeRoot = window.Shopify?.routes?.root || '/';
  const money = (cents) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(cents / 100);

  const rewardLevels = () => [
    {
      enabled: root.dataset.reward1Enabled === 'true',
      threshold: Number(root.dataset.threshold1 || 15000),
      reward: root.dataset.reward1 || 'FREE SHIPPING đồ khô',
    },
    {
      enabled: root.dataset.reward2Enabled === 'true',
      threshold: Number(root.dataset.threshold2 || 25000),
      reward: root.dataset.reward2 || 'QUÀ TẶNG',
    },
    {
      enabled: root.dataset.reward3Enabled === 'true',
      threshold: Number(root.dataset.threshold3 || 35000),
      reward: root.dataset.reward3 || 'QUÀ ĐẶC BIỆT',
    },
  ].filter((level) => level.enabled).sort((a, b) => a.threshold - b.threshold);

  const rewardState = (total) => {
    const levels = rewardLevels();
    const complete = root.dataset.complete || 'Bạn đã đạt tất cả ưu đãi';
    const achieved = levels.filter((level) => total >= level.threshold);
    const next = levels.find((level) => total < level.threshold);

    if (!levels.length) return { message: '', levels, achieved, next };

    if (next) {
      const remaining = next.threshold - total;
      if (achieved.length) {
        const achievedNames = achieved.map((level) => level.reward).join(', ');
        return {
          message: `✅ Đã đạt <strong>${achievedNames}</strong>. Thêm <strong>${money(remaining)}</strong> để nhận <strong>${next.reward}</strong>.`,
          levels, achieved, next,
        };
      }
      return {
        message: `🚚 Thêm <strong>${money(remaining)}</strong> để nhận <strong>${next.reward}</strong>.`,
        levels, achieved, next,
      };
    }

    return {
      message: `🎉 <strong>${complete}</strong>`,
      levels, achieved, next: null,
    };
  };

  const updateUI = (cart) => {
    document.querySelectorAll('[data-cdb-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count < 1;
    });

    const total = Number(cart.total_price || 0);
    const state = rewardState(total);
    const maxThreshold = Math.max(...state.levels.map((level) => level.threshold), 1);
    const pct = Math.min((total / maxThreshold) * 100, 100);

    const msg = root.querySelector('[data-cdb-reward-message]');
    const fill = root.querySelector('[data-cdb-reward-fill]');
    if (msg) msg.innerHTML = state.message;
    if (fill) {
      fill.style.setProperty('--cdb-progress', `${pct}%`);
      fill.dataset.progress = String(Math.round(pct));
      const progressbar = fill.closest('[role="progressbar"]');
      progressbar?.setAttribute('aria-valuenow', String(Math.round(pct)));
      progressbar?.setAttribute('aria-valuetext', `${money(total)} trong tổng mốc ${money(maxThreshold)}`);
    }

    root.querySelectorAll('[data-cdb-reward-level]').forEach((row, index) => {
      const threshold = Number(row.dataset.threshold || 0);
      const status = row.querySelector('[data-cdb-reward-status]');
      const achieved = total >= threshold;
      const active = !achieved && state.next && threshold === state.next.threshold;
      row.classList.toggle('is-achieved', achieved);
      row.classList.toggle('is-active', Boolean(active));
      if (status) status.textContent = achieved ? '✓' : String(index + 1);
    });

    root.querySelectorAll('[data-cdb-qty]').forEach((control) => {
      const id = Number(control.dataset.variantId);
      const item = cart.items.find((line) => line.variant_id === id);
      const qty = item ? item.quantity : 0;
      const input = control.querySelector('[data-cdb-qty-input]');
      if (input && document.activeElement !== input) input.value = String(qty);
      control.dataset.lineKey = item ? item.key : '';
    });
  };

  const getCart = () => fetch(`${routeRoot}cart.js`, {
    headers: { Accept: 'application/json' },
  }).then((response) => {
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  });

  const setQuantity = async (control, requestedQuantity) => {
    if (!control || control.getAttribute('aria-busy') === 'true') return;
    const id = Number(control.dataset.variantId);
    const input = control.querySelector('[data-cdb-qty-input]');
    const quantity = Math.max(0, Math.floor(Number(requestedQuantity) || 0));
    control.setAttribute('aria-busy', 'true');
    if (input) input.value = String(quantity);

    try {
      const cart = window.CDBCart
        ? await window.CDBCart.setVariantQuantity(id, quantity, input)
        : await getCart();
      updateUI(cart);
    } catch (error) {
      console.error(error);
    } finally {
      control.removeAttribute('aria-busy');
    }
  };

  const currentQuantity = (control) => {
    const input = control.querySelector('[data-cdb-qty-input]');
    return Math.max(0, Math.floor(Number(input?.value) || 0));
  };

  root.addEventListener('click', (event) => {
    const menu = event.target.closest('[data-cdb-menu-toggle]');
    if (menu) {
      const panel = root.querySelector('[data-cdb-menu-panel]');
      panel?.classList.toggle('is-open');
      menu.setAttribute('aria-expanded', panel?.classList.contains('is-open') ? 'true' : 'false');
      return;
    }

    const button = event.target.closest('[data-cdb-qty-action]');
    if (!button) return;

    const control = button.closest('[data-cdb-qty]');
    const delta = button.dataset.cdbQtyAction === 'plus' ? 1 : -1;
    const next = Math.max(0, currentQuantity(control) + delta);
    setQuantity(control, next);
  });

  root.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cdb-qty-input]');
    if (!input) return;
    setQuantity(input.closest('[data-cdb-qty]'), input.value);
  });

  root.addEventListener('keydown', (event) => {
    const input = event.target.closest('[data-cdb-qty-input]');
    if (!input) return;
    if (event.key === 'Enter') {
      event.preventDefault();
      input.blur();
    }
  });

  root.addEventListener('input', (event) => {
    const input = event.target.closest('[data-cdb-qty-input]');
    if (!input) return;
    input.value = input.value.replace(/[^0-9]/g, '');
  });

  document.addEventListener('cdb:cart-updated', (event) => {
    if (event.detail?.cart) updateUI(event.detail.cart);
  });

  getCart().then(updateUI).catch(console.error);
})();
